/**
 * Parse pasted text into valid ISBNs (10 or 13 digits).
 * Splits on newlines, commas, and spaces; dedupes.
 */
export function parseIsbnsFromPaste(text: string): string[] {
  const tokens = text.split(/[\s,]+/).map((s) => s.trim()).filter(Boolean);
  const isbnRegex = /^\d{10,13}$/;
  const seen = new Set<string>();
  const isbns: string[] = [];
  for (const t of tokens) {
    if (isbnRegex.test(t) && !seen.has(t)) {
      seen.add(t);
      isbns.push(t);
    }
  }
  return isbns;
}
